<div class="bc-margin-top-2">
	<div bc-card class="det" [ngStyle]="{'border-top-color': colors[indice]}">
		<div class="bc-card-body">
			<div class="bc-card-info bc-align-right">
				<p class="boli">
					<span class="boli" [innerHTML]="textoCard"></span>
				</p>
				<hr>
				<p class="texto-card">
					Y paga <br *ngIf="saltoLinea">
					<span class="bol">{{detal.feeDuringGracePeriod
            .slice(0,detal.feeDuringGracePeriod.length - 3)}}<span class="zero">{{detal.feeDuringGracePeriod
              .slice(detal.feeDuringGracePeriod.length - 3,detal.feeDuringGracePeriod.length)}}</span>
          </span> <br *ngIf="saltoLinea">
          {{periodicidad | lowercase}}
          <br> durante el periodo de gracia.
				</p>
			</div>
			<div class="bc-align-center card-container">
				<button
					bc-button
					[typeButton]="buttonType"
					sizeButton="small"
					routerLink="/detalle"
					class="pont"
					(click)="putSelectedAlernative()"
				>
					Ver detalle
				</button>
			</div>
		</div>
	</div>
</div>
